import { useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cameraService } from "client-app-core";
import { getPtzLockType, isSharedFeed } from "orion-components/GlobalData/PTZPrivilege/selectors";

const TEMP_LOCK_DEBOUNCE_MS = 5000; // 5 seconds

export const useEnsurePTZTempLock = cameraId => {
	const dispatch = useDispatch();
	const lockType = useSelector(state => getPtzLockType(state, { cameraId }));
	const feedShared = useSelector(state => isSharedFeed(state, { cameraId }));
	const lastTempLockRef = useRef(0);

	const ensureTempLock = useCallback(() => {
		// Never request temp lock if camera is under explicit lock
		if (lockType === "explicit") return;

		const now = Date.now();

		// Debounce server calls
		if (now - lastTempLockRef.current < TEMP_LOCK_DEBOUNCE_MS) {
			return;
		}

		lastTempLockRef.current = now;

		// Shared feed: respect owner org rules – no client-side temp lock
		if (feedShared) return;

		cameraService.setTemporaryLock(cameraId);
	}, [cameraId, dispatch, feedShared, lockType]);

	return ensureTempLock;
};
